import { Button } from "@/components/Button";
import { cn } from "@/utils/helpers";
import { Download, Loader2 } from "lucide-react";
import { useState } from "react";
const downloadCVButtonContent = {
  cvPath: "/Dimitar-Daskalov-CV.pdf",
  fileName: "Dimitar-Daskalov-CV.pdf",
  buttonText: "Download CV",
  ariaLabel: "Download CV as PDF"
};
const ICON_CLASSES = "w-5 h-5";
const downloadFile = async (path: string, fileName: string) => {
  const response = await fetch(path);
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
export const DownloadCV = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      await downloadFile(downloadCVButtonContent.cvPath, downloadCVButtonContent.fileName);
    } catch (error) {
      console.error("Failed to download CV:", error);
    } finally {
      setIsDownloading(false);
    }
  };
  return <Button onClick={handleDownload} variant="primary" icon={isDownloading ? <Loader2 className={cn(ICON_CLASSES, "animate-spin")} /> : <Download className={ICON_CLASSES} />} className="w-full lg:w-auto" aria-label={downloadCVButtonContent.ariaLabel} disabled={isDownloading} translate="no">
      {downloadCVButtonContent.buttonText}
    </Button>;
};